export default __webpack_public_path__ + "static/0228-a5d02529e436d51136c9c80abede8d41.png";